function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.5 1.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.5 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.5,19a1,1,0,0,0-1,1,2,2,0,0,1-4,0V5a5.006,5.006,0,0,0-5-5h-2a5.006,5.006,0,0,0-5,5v.5a1,1,0,0,0,2,0V5a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3V20a4,4,0,0,0,8,0A1,1,0,0,0,21.5,19Z",
  fill: "#ff7e00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,15a2.5,2.5,0,0,0,5,0V5.75a.25.25,0,0,0-.25-.25h-4.5a.25.25,0,0,0-.25.25Z",
  fill: "#ff7e00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.947,4.276l-2-4a.521.521,0,0,0-.894,0l-2,4a.154.154,0,0,0,.138.224h4.618a.154.154,0,0,0,.138-.224Z",
  fill: "#ff7e00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.75,13a.25.25,0,0,0,.25-.25V10.5A2.5,2.5,0,0,0,8.5,8h-2a.25.25,0,0,0-.25.25v4.5A.25.25,0,0,0,6.5,13Z",
  fill: "#ffb238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.75,8.25A.25.25,0,0,0,4.5,8h-2A2.5,2.5,0,0,0,0,10.5v2.25A.25.25,0,0,0,.25,13H4.5a.25.25,0,0,0,.25-.25Z",
  fill: "#ffb238"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,18.5a5.5,5.5,0,1,0,11,0V14.75a.25.25,0,0,0-.25-.25H.25a.25.25,0,0,0-.25.25Z",
  fill: "#ffb238"
})));

var SvgUiDesigner = function SvgUiDesigner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUiDesigner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ui_designer.b4cd093d.svg";
export { ForwardRef as ReactComponent };